import { forwardRef } from "react";
function SvgActivitiesIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={14}
        height={16}
        x={3}
        y={3}
        stroke="#333"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={2}
      />
      <path
        stroke="#333"
        strokeLinecap="round"
        strokeWidth={2}
        d="M7 7h6m-6 4h6m-6 4h4"
      />
      <circle cx={15} cy={15} r={6} fill="#fff" stroke="#333" strokeWidth={2} />
      <path
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17.5 13c-2.667 3.056-3 5-3 5l-2-2"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgActivitiesIcon);
export default ForwardRef;
